import { IntlFormatters } from 'react-intl';

export class Formatter {
  constructor(
    private formatMessage: IntlFormatters['formatMessage'],
    private category?: string,
    private keyword?: string,
    private account?: string
  ) {}

  get headline(): string {
    return this.formatMessage({ id: this.descriptorId }, this.values);
  }

  private get descriptorId() {
    if (this.keyword) {
      return 'HEADLINE_KEYWORD';
    }

    if (this.account) {
      return 'HEADLINE_ACCOUNT';
    }

    if (this.category) {
      return 'HEADLINE_CATEGORY';
    }

    return 'HEADLINE';
  }

  private get values() {
    if (this.keyword) {
      return { keyword: this.keyword };
    }

    if (this.account) {
      return { account: this.account };
    }

    if (this.category) {
      return { category: this.category };
    }
  }
}
